/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConsumedMeal } from '../models/ConsumedMeal';
import type { CreateUserMealRequest } from '../models/CreateUserMealRequest';
import type { Meal } from '../models/Meal';
import type { NormalizeMealRequest } from '../models/NormalizeMealRequest';
import type { RecommendedMeal } from '../models/RecommendedMeal';
import type { Unit } from '../models/Unit';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MealControllerService {
    /**
     * @returns Meal OK
     * @throws ApiError
     */
    public static getAllMeals(): CancelablePromise<Array<Meal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Unit OK
     * @throws ApiError
     */
    public static updateMeal(
        requestBody: Meal,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/meals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Meal OK
     * @throws ApiError
     */
    public static saveMeal(
        requestBody: Meal,
    ): CancelablePromise<Meal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param mealId
     * @param newRating
     * @returns Unit OK
     * @throws ApiError
     */
    public static rateMeal(
        mealId: string,
        newRating: number,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/{mealId}/rate',
            path: {
                'mealId': mealId,
            },
            query: {
                'newRating': newRating,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @param aiGenerated
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static uploadImage(
        id: string,
        aiGenerated: boolean = false,
        formData?: {
            file: Blob;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/{id}/image',
            path: {
                'id': id,
            },
            query: {
                'aiGenerated': aiGenerated,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Unit OK
     * @throws ApiError
     */
    public static saveUserMealForUser(
        requestBody: CreateUserMealRequest,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/usermeal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Meal OK
     * @throws ApiError
     */
    public static recommendMeals(): CancelablePromise<Array<Meal>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/recommend',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Meal OK
     * @throws ApiError
     */
    public static normalizeMeal(
        requestBody: NormalizeMealRequest,
    ): CancelablePromise<Meal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/normalize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ConsumedMeal OK
     * @throws ApiError
     */
    public static getConsumedMeals(): CancelablePromise<Array<ConsumedMeal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/consumed',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ConsumedMeal OK
     * @throws ApiError
     */
    public static saveConsumedMeal(
        requestBody: ConsumedMeal,
    ): CancelablePromise<ConsumedMeal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/consumed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param clientId
     * @param requestBody
     * @returns Unit OK
     * @throws ApiError
     */
    public static saveUserMeal(
        clientId: string,
        requestBody: Meal,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/client/{clientId}',
            path: {
                'clientId': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param mealId
     * @returns Meal OK
     * @throws ApiError
     */
    public static calculateMealsWeights(
        mealId: string,
    ): CancelablePromise<Meal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/meals/calculate/{mealId}',
            path: {
                'mealId': mealId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param userId
     * @returns RecommendedMeal OK
     * @throws ApiError
     */
    public static recommendForUser(
        userId: string,
    ): CancelablePromise<Array<RecommendedMeal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/recommend/user/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param like
     * @returns Meal OK
     * @throws ApiError
     */
    public static getLikeMeals(
        like: string,
    ): CancelablePromise<Array<Meal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/like/{like}',
            path: {
                'like': like,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param mealId
     * @param imageId
     * @returns string OK
     * @throws ApiError
     */
    public static getMealImage(
        mealId: string,
        imageId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/id/{mealId}/image/id/{imageId}',
            path: {
                'mealId': mealId,
                'imageId': imageId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns Meal OK
     * @throws ApiError
     */
    public static getMeal(
        id: string,
    ): CancelablePromise<Meal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/id/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns Unit OK
     * @throws ApiError
     */
    public static deleteMeal(
        id: string,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/meals/id/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns Meal OK
     * @throws ApiError
     */
    public static getAllMealsForClient(
        id: string,
    ): CancelablePromise<Array<Meal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/client/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Meal OK
     * @throws ApiError
     */
    public static getAllMealsByAuthor(): CancelablePromise<Array<Meal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/meals/author',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns Unit OK
     * @throws ApiError
     */
    public static deleteUserMeal(
        id: string,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/meals/usermeal/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns Unit OK
     * @throws ApiError
     */
    public static deleteConsumedMeal(
        id: string,
    ): CancelablePromise<Unit> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/meals/consumed/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
